import { useState } from 'react';
import cn from 'classnames';
import Modal from '../../General/Modal';
import { ProductForm } from './ProductForm';
import './EditProductModal.scss';

/**
 * @typedef {Object} ProductSaveData
 * @property {Object} product - The updated product object
 * @property {boolean} userCreatedBrand - Whether a new brand was created during save
 * @property {boolean} userCreatedProduct - Whether this is a new product (vs update)
 */

/**
 * @param {Object} props - Component props
 * @param {number} props.productId - ID of the product to edit
 * @param {string} [props.className] - Additional CSS classes for the edit button
 * @param {'button'|'text'} [props.variant] - How to render the edit button
 * @param {function(ProductSaveData): void} [props.onSave] - Callback fired when product is saved
 * @returns {JSX.Element} Edit button that opens modal, or modal itself when open
 */
export const EditProductModal = ({ productId, className, onSave, variant = 'button' }) => {
  const [open, setOpen] = useState(false);

  /**
   * @param {ProductSaveData} changes - Object containing product changes and metadata
   */
  const handleSave = changes => {
    onSave?.(changes);
    setOpen(false);
  };

  if (!open) {
    return (
      <button
        className={cn('edit-product-button', className, { 'as-text': variant === 'text', 'as-button': variant === 'button' })}
        onClick={() => setOpen(true)}
      >
        Edit
      </button>
    );
  }

  return (
    <Modal close={() => setOpen(false)} className='edit-product-modal'>
      <ProductForm productId={productId} onSave={handleSave} onBackClick={() => setOpen(false)} />
    </Modal>
  );
};
